// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingItemList-textEllipsis-Zx7bI {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.ListingItemList-listItemListContainer-NrXUF {
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	border: 1px solid var(--primary-border);
	border-radius: 15px;
	background: var(--background-primary);
	overflow: hidden;
}

.ListingItemList-listPhotoColumn-XIe2h {
	width: 38%;
	min-width: 260px;
	position: relative;
}

.ListingItemList-listInfoColumn-T5DK5 {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	padding: 16px 20px;
	min-width: 0;
	text-decoration: none !important;
	cursor: pointer;
}

.ListingItemList-listPriceColumn-HPjBC {
	width: 26%;
	min-width: 180px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: end;
	    -ms-flex-align: end;
	        align-items: flex-end;
	gap: 4px;
	padding: 16px 20px;
}

.ListingItemList-listTitle-T7Cu9 {
	font-size: 16px;
	font-weight: bold;
	color: var(--primary-foreground);
	margin: 0 0 6px;
}

.ListingItemList-listCity-JKBvq {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 6px;
	font-size: 14px;
	color: var(--secondary-foreground);
	margin: 0 0 12px;
}

.ListingItemList-listAmenities-PxBbf {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px 16px;
	margin-bottom: 14px;
}

.ListingItemList-amenityTag-W1Qmw {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 6px;
	color: var(--secondary-foreground);
	font-size: 13px;
	line-height: 18px;
	white-space: nowrap;
}

.ListingItemList-amenityIcon-II197 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	width: 14px;
	height: 14px;
	-o-object-fit: contain;
	   object-fit: contain;
	color: var(--secondary-foreground);
}

.ListingItemList-amenityIcon-II197 svg {
	width: 14px;
	height: auto;
}

.ListingItemList-cityIcon-w72eA {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	width: 13px;
	height: 13px;
	color: var(--secondary-foreground);
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.ListingItemList-cityIcon-w72eA svg {
	width: 13px;
	height: auto;
}

.ListingItemList-qrPayment-skVlw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 8px;
	font-size: 14px;
	font-weight: 600;
	color: var(--secondary-esmeralda);
	margin: 0;
}

.ListingItemList-qrIcon-Vmmq_ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	color: var(--secondary-esmeralda);
	font-size: 14px;
}

.ListingItemList-qrIcon-Vmmq_ svg {
	width: 15px;
	height: auto;
}

.ListingItemList-priceWrap-ZP4f_ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
	gap: 0px;
}

.ListingItemList-priceValue-XoxWu {
	font-size: 24px;
	font-weight: bold;
	color: var(--primary-color);
	line-height: 1;
}

.ListingItemList-pricePerNight-azCke {
	font-size: 16px;
	color: var(--secondary-oscuro);
	margin-bottom: 24px;
}

.ListingItemList-viewDetailsBtn-rGZzG {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	background: var(--primary-color);
	color: #ffffff !important;
	border: none;
	border-radius: 35px;
	padding: 10px 24px;
	font-size: 14px;
	font-weight: bold;
	cursor: pointer;
	text-decoration: none !important;
	white-space: nowrap;
}

.ListingItemList-viewDetailsBtn-rGZzG:hover,
.ListingItemList-viewDetailsBtn-rGZzG:active,
.ListingItemList-viewDetailsBtn-rGZzG:focus {
	background: var(--primary-bg-hover);
	color: #ffffff !important;
	text-decoration: none;
}

.ListingItemList-heartIcon-OwQqj {
	position: absolute;
}

@media screen and (max-width: 991px) {
	.ListingItemList-listItemListContainer-NrXUF {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
	}

	.ListingItemList-listPhotoColumn-XIe2h {
		width: 100%;
		min-width: 0;
	}

	.ListingItemList-listPriceColumn-HPjBC {
		width: 100%;
		min-width: 0;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		    -ms-flex-direction: row;
		        flex-direction: row;
		-webkit-box-align: center;
		    -ms-flex-align: center;
		        align-items: center;
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
		gap: 12px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/ListingItem/ListingItemList.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uCAAuC;CACvC,mBAAmB;CACnB,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,kBAAkB;CAClB,YAAY;CACZ,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,sBAAqB;KAArB,mBAAqB;SAArB,qBAAqB;CACrB,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAe;KAAf,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;CACrB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,gCAAgC;CAChC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;;;CAGC,mCAAmC;CACnC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;CACvB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,8BAAmB;EAAnB,6BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;CACV;AACD","sourcesContent":[".textEllipsis {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.listItemListContainer {\n\twidth: 100%;\n\tdisplay: flex;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 15px;\n\tbackground: var(--background-primary);\n\toverflow: hidden;\n}\n\n.listPhotoColumn {\n\twidth: 38%;\n\tmin-width: 260px;\n\tposition: relative;\n}\n\n.listInfoColumn {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tpadding: 16px 20px;\n\tmin-width: 0;\n\ttext-decoration: none !important;\n\tcursor: pointer;\n}\n\n.listPriceColumn {\n\twidth: 26%;\n\tmin-width: 180px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-end;\n\tgap: 4px;\n\tpadding: 16px 20px;\n}\n\n.listTitle {\n\tfont-size: 16px;\n\tfont-weight: bold;\n\tcolor: var(--primary-foreground);\n\tmargin: 0 0 6px;\n}\n\n.listCity {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 0 0 12px;\n}\n\n.listAmenities {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tgap: 12px 16px;\n\tmargin-bottom: 14px;\n}\n\n.amenityTag {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tcolor: var(--secondary-foreground);\n\tfont-size: 13px;\n\tline-height: 18px;\n\twhite-space: nowrap;\n}\n\n.amenityIcon {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 14px;\n\theight: 14px;\n\tobject-fit: contain;\n\tcolor: var(--secondary-foreground);\n}\n\n.amenityIcon svg {\n\twidth: 14px;\n\theight: auto;\n}\n\n.cityIcon {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 13px;\n\theight: 13px;\n\tcolor: var(--secondary-foreground);\n\tflex-shrink: 0;\n}\n\n.cityIcon svg {\n\twidth: 13px;\n\theight: auto;\n}\n\n.qrPayment {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: var(--secondary-esmeralda);\n\tmargin: 0;\n}\n\n.qrIcon {\n\tdisplay: flex;\n\tcolor: var(--secondary-esmeralda);\n\tfont-size: 14px;\n}\n\n.qrIcon svg {\n\twidth: 15px;\n\theight: auto;\n}\n\n.priceWrap {\n\tdisplay: flex;\n\talign-items: baseline;\n\tgap: 0px;\n}\n\n.priceValue {\n\tfont-size: 24px;\n\tfont-weight: bold;\n\tcolor: var(--primary-color);\n\tline-height: 1;\n}\n\n.pricePerNight {\n\tfont-size: 16px;\n\tcolor: var(--secondary-oscuro);\n\tmargin-bottom: 24px;\n}\n\n.viewDetailsBtn {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: var(--primary-color);\n\tcolor: #ffffff !important;\n\tborder: none;\n\tborder-radius: 35px;\n\tpadding: 10px 24px;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcursor: pointer;\n\ttext-decoration: none !important;\n\twhite-space: nowrap;\n}\n\n.viewDetailsBtn:hover,\n.viewDetailsBtn:active,\n.viewDetailsBtn:focus {\n\tbackground: var(--primary-bg-hover);\n\tcolor: #ffffff !important;\n\ttext-decoration: none;\n}\n\n.heartIcon {\n\tposition: absolute;\n}\n\n@media screen and (max-width: 991px) {\n\t.listItemListContainer {\n\t\tflex-direction: column;\n\t}\n\n\t.listPhotoColumn {\n\t\twidth: 100%;\n\t\tmin-width: 0;\n\t}\n\n\t.listPriceColumn {\n\t\twidth: 100%;\n\t\tmin-width: 0;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tgap: 12px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textEllipsis": `ListingItemList-textEllipsis-Zx7bI`,
	"listItemListContainer": `ListingItemList-listItemListContainer-NrXUF`,
	"listPhotoColumn": `ListingItemList-listPhotoColumn-XIe2h`,
	"listInfoColumn": `ListingItemList-listInfoColumn-T5DK5`,
	"listPriceColumn": `ListingItemList-listPriceColumn-HPjBC`,
	"listTitle": `ListingItemList-listTitle-T7Cu9`,
	"listCity": `ListingItemList-listCity-JKBvq`,
	"listAmenities": `ListingItemList-listAmenities-PxBbf`,
	"amenityTag": `ListingItemList-amenityTag-W1Qmw`,
	"amenityIcon": `ListingItemList-amenityIcon-II197`,
	"cityIcon": `ListingItemList-cityIcon-w72eA`,
	"qrPayment": `ListingItemList-qrPayment-skVlw`,
	"qrIcon": `ListingItemList-qrIcon-Vmmq_`,
	"priceWrap": `ListingItemList-priceWrap-ZP4f_`,
	"priceValue": `ListingItemList-priceValue-XoxWu`,
	"pricePerNight": `ListingItemList-pricePerNight-azCke`,
	"viewDetailsBtn": `ListingItemList-viewDetailsBtn-rGZzG`,
	"heartIcon": `ListingItemList-heartIcon-OwQqj`
};
module.exports = ___CSS_LOADER_EXPORT___;
